import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import {
  Stack,
  Table,
  Dialog,
  Button,
  Divider,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  DialogTitle,
  DialogContent,
  DialogActions,
  TableContainer,
} from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useForm } from 'react-hook-form';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import useCurrentDateTime from 'src/hooks/use-current-date-time';
import { DepositTxType } from 'src/type/deposit';
import axios, { endpoints } from 'src/utils/axios';
import { toastError } from 'src/utils/format-error';
import { fNumber } from 'src/utils/format-number';
import * as Yup from 'yup';

const Schema = Yup.object().shape({
  reason: Yup.string(),
});

const defaultValues = {
  reason: '',
};

type Props = {
  open: boolean;
  isCreateAndApprove?: boolean;
  onClose: VoidFunction;
  tx: DepositTxType;
  handleReload: VoidFunction;
};

export default function DepositApproveDialog({
  open,
  onClose,
  tx,
  isCreateAndApprove = false,
  handleReload,
}: Props) {
  const currentDateTime = useCurrentDateTime();

  const methods = useForm({
    mode: 'onChange',
    resolver: yupResolver(Schema),
    defaultValues,
  });

  const {
    handleSubmit,
    reset,

    formState: { isSubmitting },
  } = methods;

  const onSubmit = handleSubmit(async (values) => {
    try {
      await axios.post(endpoints.transactions.deposit.approve(tx.id), {
        note: values.reason,
        currentDateTime,
      });
      if (!isCreateAndApprove) {
        handleReload();
      }
      beforeClose();
      enqueueSnackbar('อัพเดทข้อมูลสำเร็จ', { variant: 'success' });
    } catch (error) {
      toastError(error);
    }
  });

  const beforeClose = () => {
    if (isCreateAndApprove) {
      handleReload();
    }
    reset(defaultValues);
    onClose();
  };

  return (
    <Dialog open={open} onClose={beforeClose} maxWidth="sm" fullWidth>
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <DialogTitle>
          อนุมัติรายการฝาก {tx.product.name} {tx.amount} {tx.unitName}
        </DialogTitle>

        <DialogContent>
          <Stack spacing={3}>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell />
                    <TableCell align="center">น้ำหนัก</TableCell>
                    <TableCell align="center">จำนวน</TableCell>
                    {/* <TableCell align="center">ค่าธรรมเนียม</TableCell> */}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {tx?.productRedeemFees?.map((fee) => (
                    <TableRow key={fee.id}>
                      <TableCell>{fee?.productRedeemFee?.name}</TableCell>
                      <TableCell align="center">
                        {fee?.productRedeemFee?.weight} {fee?.productRedeemFee?.unitName}
                      </TableCell>
                      <TableCell align="center">{fNumber(fee?.amount || 0)}</TableCell>
                      {/* <TableCell align="center">
                    {fNumber((fee?.amount || 0) * (fee?.productRedeemFee?.fee || 0))}
                  </TableCell> */}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>

              <Divider style={{ borderStyle: 'dashed' }} />

              <Table size="small" sx={{ mt: 3 }}>
                <TableHead>
                  <TableRow>
                    <TableCell>น้ำหนักทองทั้งหมด</TableCell>
                    <TableCell align="center">{fNumber(tx?.amount || 0)} บาท</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell>ค่าธรรมเนียมทั้งหมด</TableCell>
                    <TableCell align="center">{fNumber(tx?.fee || 0)} THB</TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </TableContainer>

            <RHFTextField
              multiline
              rows={3}
              name="reason"
              placeholder="หมายเหตุ"
              InputLabelProps={{ shrink: true }}
            />
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button variant="outlined" onClick={beforeClose} disabled={isSubmitting}>
            ยกเลิก
          </Button>
          <LoadingButton variant="contained" type="submit" loading={isSubmitting}>
            ดำเนินการต่อ
          </LoadingButton>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
}
